import React from 'react';

import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import blueHeart from '../assets/blueCheckHeart.svg';
import yellowHeart from '../assets/yellowCheckHeart.svg';

const useStyles = makeStyles((theme) => ({
  heartGraphicsCont: {
    width: '51%',
    margin: '3.125rem 0',
    [theme.breakpoints.down('md')]: {
      width: '40%'
    },
    [theme.breakpoints.down('sm')]: {
      width: '75%'
    }
  }
}));

const FindingASolutionHearts = () => {
  const classes = useStyles();
  const { ref, inView } = useInView({ triggerOnce: 'true' });

  const renderer = (
    <>
      <motion.img
        initial={{ y: 50 }}
        animate={{ y: 0, transition: { delay: 0.2, ease: 'easeInOut' } }}
        src={blueHeart}
        alt="blue heart with checkmark"
        style={{ padding: '1rem' }}
      />
      <motion.img
        initial={{ y: 50 }}
        animate={{ y: 0, transition: { delay: 0.3, ease: 'easeInOut' } }}
        src={yellowHeart}
        alt="yellow heart with checkmark"
        style={{ padding: '1rem' }}
      />
      <motion.img
        initial={{ y: 50 }}
        animate={{ y: 0, transition: { delay: 0.4, ease: 'easeInOut' } }}
        src={yellowHeart}
        alt="yellow heart with checkmark"
        style={{ padding: '1rem' }}
      />
      <motion.img
        initial={{ y: 50 }}
        animate={{ y: 0, transition: { delay: 0.5, ease: 'easeInOut' } }}
        src={yellowHeart}
        alt="yellow heart with checkmark"
        style={{ padding: '1rem' }}
      />
      <motion.img
        initial={{ y: 50 }}
        animate={{ y: 0, transition: { delay: 0.6, ease: 'easeInOut' } }}
        src={yellowHeart}
        alt="yellow heart with checkmark"
        style={{ padding: '1rem' }}
      />
      <motion.img
        initial={{ y: 50 }}
        animate={{ y: 0, transition: { delay: 0.8, ease: 'easeInOut' } }}
        src={yellowHeart}
        alt="yellow heart with checkmark"
        style={{ padding: '1rem' }}
      />
    </>
  );

  return (
    <Grid ref={ref} container justifyContent="space-between" className={classes.heartGraphicsCont}>
      {inView ? renderer : null}
    </Grid>
  );
};

export default FindingASolutionHearts;
